exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.customer-coupone-send[data-v-224c58a0] {\n  padding: 20px;\n}\n.card-header[data-v-224c58a0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.search-form[data-v-224c58a0] {\n  margin-bottom: 20px;\n}\n.pagination[data-v-224c58a0] {\n  margin-top: 20px;\n  text-align: right;\n}\n.dialog-footer[data-v-224c58a0] {\n  text-align: right;\n}\n", ""]);

// exports
